export function saveAs(uri, filename) {
  let link = document.createElement("a");
  if (typeof link.download === "string") {
    link.href = uri;
    link.download = filename;
    //Firefox requires the link to be in the body
    document.body.appendChild(link);
    //simulate click
    link.click();
    //remove the link when done
    document.body.removeChild(link);
  } else {
    window.open(uri);
  }
}

export function getDownloadTileName(name, type) {
  // format yyyy-mm-dd_[type]-<name>
  return (
    formatDate(new Date()) +
    "_" +
    type +
    "-" +
    name.replace(/[^a-z0-9]/gi, "_").toLowerCase() +
    ".png"
  );
}

export function formatDate(date) {
  let year = date.getFullYear().toString();
  let month = (date.getMonth() + 101).toString().substring(1);
  let day = (date.getDate() + 100).toString().substring(1);
  return year + "-" + month + "-" + day;
}
